import request from '@/utils/request'

/**
 * 搜索项目
 * @method search
 * @param {Object} filters 筛选条件
 * @param {Object} options 搜索选项
 * @return {Promise} 异步返回项目信息
 */
export function search(filters, options) {
  return request({
    url: '/api/project/search',
    method: 'post',
    data: {filters,options}
  })
}

export function create(project) {
  return request({
    url: '/api/project/create',
    method: 'post',
    data: project
  })
}

export function save(projects) {
  return request({
    url: '/api/project/save',
    method: 'put',
    data: projects
  })
}

/**
 * 移除项目
 * @method remove
 * @param {Long} id 项目id
 * @return {Promise} 异步返回操作结果
 */
export function remove(id) {
  return request({
    url: '/api/project/'+id,
    method: 'delete'
  })
}

/**
 * 批量移除项目
 * @method nullify
 * @param {Array} ids 项目id数组
 * @return {Promise} 异步返回操作结果
 */
 export function removeBatch(ids) {
  return request({
    url: '/api/project?ids='+ids,
    method: 'delete'
  })
}

export function addNode({parentId,type}) {
  return request({
    url: '/api/project/addNode',
    method: 'put',
    data: {parentId,type}
  })
}

export function removeNode(projectId) {
  return request({
    url: '/api/project/removeNode',
    method: 'delete',
    params: {projectId}
  })
}
export function moveNode({sourceProjectId, targetProjectId, position}) {
  return request({
    url: '/api/project/moveNode',
    method: 'put',
    params: {sourceProjectId, targetProjectId, position}
  })
}

export function setting({projectId,settings}) {
  return request({
    url: '/api/project/setting',
    method: 'put',
    data: {projectId,settings}
  })
}

export function getSetting({projectId, options}) {
  return request({
    url: '/api/project/setting',
    method: 'get',
    params: {projectId, options}
  })
}

export function load(projectId){
  return request({
    url: '/api/project/load?projectId='+projectId,
    method: 'get'
  })
}

export function defaultValue(projectType){
  let url = '/api/project/defaultValue'
  if(projectType){
    url += '?projectType='+projectType
  }
  return request({
    url,
    method: 'get'
  })
}

export function importProject(filePath, options){
  let url = '/api/project/import'
  return request({
    url,
    method: 'post',
    timeout: 30000,
    data:{filePath, options}
  })
}
export function getProjectFiles(projectId){
  let url = `/api/project/files?projectId=${projectId}`
  return request({
    url,
    method: 'get'
  })
}
export function addProjectFiles(topProjectId, files){
  let url = '/api/project/files'
  return request({
    url,
    method: 'post',
    data:{topProjectId, files}
  })
}
export function getMyProjects(options){
  let url = '/api/project/mine'
  return request({
    url,
    method: 'get',
    params: options
  })
}
export function getAllTopProjects(options){
  let url = '/api/project/all'
  return request({
    url,
    method: 'get',
    params: options
  })
}
export function deleteProjects(topProjectIds){
  let url = '/api/project/batchDelete'
  return request({
    url,
    method: 'delete',
    data:{topProjectIds}
  })
}

export function reviewProjects(topProjectIds, pass){
  let url = '/api/project/review'
  return request({
    url,
    method: 'put',
    data:{topProjectIds, pass}
  })
}